import React from "react";
import { FormControl, FormLabel, Grid, TextField } from "@mui/material";
import { AppelOffreSeao } from "../../model/AppelOffreSeao";
import { Trans, useTranslation } from "react-i18next";
import { DatePicker } from "@mui/x-date-pickers";
import { Processus } from "../../model/Processus";
import "../CSS/colorMessages.css";

interface AppelOffreFormProps {
  appelOffre: AppelOffreSeao;
  typeDemande: string | null;
  onChange: (updatedAppelOffre: AppelOffreSeao) => void;
  onBlur: (fieldName: string) => void;
  errorNumeroReference: string;
}

const AppelOffreForm: React.FC<AppelOffreFormProps> = ({
  appelOffre,
  typeDemande,
  onChange,
  onBlur,
  errorNumeroReference,
}) => {
  const { t } = useTranslation();
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    onChange({
      ...appelOffre,
      [name]: value,
    });
  };
  const onChangeDateLimiteReceptionPlainte = (value: Date | null) => {
    onChange({
      ...appelOffre,
      dateLimiteReceptionPlainte: value.toISOString(),
    });
  };
  const onChangeDateLimiteReceptionOffre = (value: Date | null) => {
    onChange({
      ...appelOffre,
      dateLimiteReceptionOffre: value.toISOString(),
    });
  };
  const onChangeDatePublication = (value: Date | null) => {
    onChange({
      ...appelOffre,
      datePublication: value.toISOString(),
    });
  };
  const onChangeDatePrevueConclusionContrat = (value: Date | null) => {
    onChange({
      ...appelOffre,
      datePrevueConclusionContrat: value.toISOString(),
    });
  };

  return (
    <>
      <Grid container>
        <Grid item xs={6}>
          <FormControl className="width-98" variant="standard">
            <TextField
              label={
                <Trans>
                  {t(
                    "formulairePlaintes.renseignementsProcessus.appelOffreForm.lblNumeroSeao"
                  )}
                </Trans>
              }
              name="numeroSeao"
              value={appelOffre.numeroSeao}
              onChange={handleChange}
              
              fullWidth
              margin="normal"
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth variant="standard">
            <TextField
              label={
                <Trans>
                  {t(
                    "formulairePlaintes.renseignementsProcessus.appelOffreForm.lblNumeroReference"
                  )}
                </Trans>
              }
              name="numeroReference"
              value={appelOffre.numeroReference}
              onChange={handleChange}
              onBlur={() => onBlur("numeroReference")}
              
              fullWidth
              margin="normal"
              style={{ backgroundColor: errorNumeroReference ? 'rgba(255, 204, 204, 0.036)' : 'initial' }}
            />
          </FormControl>
          {errorNumeroReference && (
            <strong id="error-numero-reference" role="alert" className="error">
              <Trans>{errorNumeroReference}</Trans>
            </strong>
          )}
        </Grid>
      </Grid>

      {typeDemande === Processus.Adjudication ? (
        <>
          <FormControl fullWidth variant="standard">
            <TextField
              label={
                <Trans>
                  {t(
                    "formulairePlaintes.renseignementsProcessus.appelOffreForm.lblTitreAvis"
                  )}
                </Trans>
              }
              name="titreAvis"
              value={appelOffre.titreAvis}
              onChange={handleChange}
              
              fullWidth
            />
          </FormControl>
          <Grid container>
            <Grid item xs={6}>
              <FormControl variant="standard">
                <FormLabel>
                  <Trans>
                    {t(
                      "formulairePlaintes.renseignementsProcessus.appelOffreForm.lblDateLimiteReceptionPlainte"
                    )}
                  </Trans>
                </FormLabel>
                <DatePicker
                  value={appelOffre.dateLimiteReceptionPlainte !== null ? new Date(appelOffre.dateLimiteReceptionPlainte) : null}
                  onChange={onChangeDateLimiteReceptionPlainte}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl variant="standard">
                <FormLabel>
                  <Trans>
                    {t(
                      "formulairePlaintes.renseignementsProcessus.appelOffreForm.lblDateLimiteReceptionOffre"
                    )}
                  </Trans>
                </FormLabel>
                <DatePicker
                  value={appelOffre.dateLimiteReceptionOffre !== null ? new Date(appelOffre.dateLimiteReceptionOffre) : null}
                  onChange={onChangeDateLimiteReceptionOffre}
                />
              </FormControl>
            </Grid>
          </Grid>
          <FormControl fullWidth variant="standard">
            <TextField
              label={
                <Trans>
                  {t(
                    "formulairePlaintes.renseignementsProcessus.appelOffreForm.lblTitreAddenda"
                  )}
                </Trans>
              }
              name="titreAddenda"
              value={appelOffre.titreAddenda}
              onChange={handleChange}
              
              fullWidth
            />
          </FormControl>
          <FormControl>
            <FormLabel>
              <Trans>
                {t(
                  "formulairePlaintes.renseignementsProcessus.appelOffreForm.lblDatePublication"
                )}
              </Trans>
            </FormLabel>
            <DatePicker
              value={appelOffre.datePublication != null ? new Date(appelOffre.datePublication) : null}
              onChange={onChangeDatePublication}
              disableFuture={true}
            />
          </FormControl>
        </>
      ) : typeDemande === Processus.Attribution ? (
        <>
          <FormControl fullWidth >
            <TextField
              label={
                <Trans>
                  {t(
                    "formulairePlaintes.renseignementsProcessus.appelOffreForm.lblTitreDocument"
                  )}
                </Trans>
              }
              name="titreDocument"
              value={appelOffre.titreDocument}
              onChange={handleChange}
              
              fullWidth
            />
          </FormControl>
          <FormControl>
            <FormLabel>
              <Trans>
                {t(
                  "formulairePlaintes.renseignementsProcessus.appelOffreForm.lblDatePrevueConclusionContrat"
                )}
              </Trans>
            </FormLabel>
            <DatePicker
              value={appelOffre.datePrevueConclusionContrat != null ? new Date(appelOffre.datePrevueConclusionContrat) : null}
              onChange={onChangeDatePrevueConclusionContrat}
            />
          </FormControl>
        </>
      ) : null}
    </>
  );
};

export default AppelOffreForm;
